















import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class VSearchBar extends Vue {
  query = "";

  search() {
    this.$emit("search", this.query);
  }
}
